import type { RoleView } from 'dfx/edge/edge.did';

export const sortRoles = (roles: RoleView[]) => {
  return roles.sort((role1, role2) => {
    return Number(role1.ordinal - role2.ordinal);
  });
};
